import { render, staticRenderFns } from "./ExcelMapperStoredSettings.vue?vue&type=template&id=46594922&scoped=true"
import script from "./ExcelMapperStoredSettings.vue?vue&type=script&lang=ts"
export * from "./ExcelMapperStoredSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46594922",
  null
  
)

export default component.exports